var exports = {
  "K": "IconButton__zX3ebA",
};

module.exports = exports;
